export const MAX_REPORT_SFTP_DESTINATIONS = 10;

export const emptyReportSftpDestination = () => ({
  client_sftp_connection_id: '',
  outbound_file_location: '',
  file_name: '',
});

export const fromReportSftpDestinationsResponse = (destinations = []) =>
  destinations.map((destination) => ({
    client_sftp_connection_id: destination.client_sftp_connection_id ?? '',
    outbound_file_location: destination.outbound_file_location ?? '',
    file_name: destination.file_name ?? '',
  }));

export const toReportSftpDestinationsPayload = (destinations = []) =>
  destinations.map((destination) => ({
    client_sftp_connection_id:
      destination.client_sftp_connection_id === ''
        ? null
        : destination.client_sftp_connection_id,
    outbound_file_location: destination.outbound_file_location,
    file_name: destination.file_name === '' ? null : destination.file_name,
  }));

export const validateReportSftpDestinations = (destinations, t) => {
  const errors = {};
  destinations.forEach((destination, index) => {
    const path = `sftp_destinations[${index}]`;
    if (!destination.client_sftp_connection_id) {
      errors[`${path}.client_sftp_connection_id`] = t(
        'reporting.form.sftpDestinations.errors.connectionRequired',
      );
    }
    const folder = destination.outbound_file_location ?? '';
    if (!folder.trim()) {
      errors[`${path}.outbound_file_location`] = t(
        'reporting.form.sftpDestinations.errors.folderRequired',
      );
    } else if (!folder.startsWith('/') || !folder.endsWith('/')) {
      errors[`${path}.outbound_file_location`] = t(
        'reporting.form.sftpDestinations.errors.folderFormat',
      );
    }
  });
  return errors;
};
